/* Copyright (c) 2022-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';

import { Plugin } from '../common/plugin';

/**
 * Injects all Plugin which were provided using injection token in app module.
 *
 * Each plugin and their dependencies are instantiated by Angular through injection token.
 * Hence all plugins are available to use **only after** the constructor is called.
 */
@Injectable({
    providedIn: 'root'
})
export abstract class PluginManager {
    private _plugins: Array<Plugin>;

    constructor(plugins: Array<Plugin>) {
        this._plugins = plugins;
    }

    /**
     * List of available plugins
     */
    get plugins(): Array<Plugin> {
        return this._plugins;
    }

    /**
     * Get first instance of the plugin of the specified type
     */
    public getPlugin<T>(type: any): T {
        return this._plugins.find(element => element instanceof type) as unknown as T;
    }
}
